import {GetChangeLogs} from '../changeLogs/changeLogs';
import Client from '../client';
import {flattenObject} from '../helpers';

const token = localStorage.getItem('token') || '';
class ChangeLogsRepository {
  getChangeLoge = async (actions: any) => {
    const makeRequest = new GetChangeLogs()
      .params(flattenObject({...actions}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);

    return response;
  };
}

export default new ChangeLogsRepository();
